import { render } from "./hop.vue?vue&type=template&id=6e5154b8&scoped=true"
import script from "./hop.vue?vue&type=script&lang=js"
export * from "./hop.vue?vue&type=script&lang=js"

import "./hop.vue?vue&type=style&index=0&id=6e5154b8&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5154b8"]])

export default __exports__